import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  source: string;
  components?: React.ComponentProps<typeof ReactMarkdown>['components'];
};

export const Markdown: React.FC<Props> = ({ className, style, source, components }: Props) => {
  const content = (
    <ReactMarkdown
      className={className}
      remarkPlugins={[remarkGfm]}
      components={{
        ...components,
        a: ({ node, ...props }) => <a {...props} target="_blank" rel="noreferrer" />,
      }}
    >
      {source}
    </ReactMarkdown>
  );

  return style ? <div style={style}>{content}</div> : content;
};
